import * as echarts from "echarts";
import { useEffect, useRef } from "react";

const PassiveBaseLoadChart = ({ data }) => {

  const chartRef = useRef(null);
  const chartInstance = useRef(null);

  useEffect(() => {

    if (!chartRef.current) return;

    chartInstance.current = echarts.init(chartRef.current);

    const resize = () => chartInstance.current?.resize();

    window.addEventListener("resize", resize);

    return () => {
      window.removeEventListener("resize", resize);
      chartInstance.current?.dispose();
    };

  }, []);

  useEffect(() => {

    if (!chartInstance.current) return;

    if (!data?.series?.length) {
      chartInstance.current.clear();
      return;
    }

    const timestamps = data.series.map(p => p.timestamp);
    const totalSeries = data.series.map(p => p.total_energy);

    const baseLoad = data.baseLoad || 0;

    const option = {

      grid: {
        left: 60,
        right: 30,
        top: 40,
        bottom: 60
      },

      tooltip: {
        trigger: "axis"
      },

      legend: {
        top: 10,
        data: ["Exceso de consumo"]
      },

      xAxis: {
        type: "time"
      },

      yAxis: {
        type: "value",
        name: "kWh"
      },

      series: [

        {
          name: "Exceso de consumo",
          type: "bar",
          data: timestamps.map((t, i) => [t, totalSeries[i]]),
          itemStyle: {
            color: "#d0d0d0"
          },
          barMaxWidth: 14,
          markLine: {
            symbol: "none",
            lineStyle: {
              color: "#3f5fa3",
              width: 2
            },
            label: {
              formatter: `Base load ≈ ${baseLoad.toFixed(2)} kWh`
            },
            data: [
              { yAxis: baseLoad }
            ]
          }
        }

      ]

    };

    chartInstance.current.setOption(option);

  }, [data]);

  return (
    <div
      ref={chartRef}
      style={{
        width: "100%",
        height: "380px"
      }}
    />
  );
};

export default PassiveBaseLoadChart;